(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zhoumong-sale-banner"] && !Shopify.designMode) return;
  try {
    (() => {
    let timer;
    const refresh = () => {
      clearTimeout(timer);
      let next = Infinity;
      document.querySelectorAll('[data-zhoumong-sale-ends-at]').forEach((banner) => {
        const remaining = Date.parse(banner.dataset.zhoumongSaleEndsAt) - Date.now();
        banner.hidden = !Number.isFinite(remaining) || remaining <= 0;
        if (!banner.hidden) next = Math.min(next, remaining);
      });
      if (Number.isFinite(next)) timer = setTimeout(refresh, Math.min(next, 2147483647));
    };
    refresh();
    document.addEventListener('DOMContentLoaded', refresh);
    document.addEventListener('shopify:section:load', refresh);
    document.addEventListener('visibilitychange', refresh);
    window.addEventListener('pageshow', refresh);
  })();
  } catch(e) { console.error(e); }
})();

})();
